// {#Edit: Create new entry for your list}
// Note: Each list must have one entry here
//       Sort your entry by Name Ascending
const QUERIES = {
  EXAMPLE_LIST: 'example-list',

  ANNOUNCEMENTS_LIST: 'announcements-list',
  GDRN_LIST: 'gdrn-list',
  MAINTENANCE_BENEFICIARY_LIST: 'maintenance-beneficiary-list',
  MAINTENANCE_CLUSTER_LIST: 'maintenance-cluster-list',
  MAINTENANCE_CONTRIBUTIONTYPE_LIST: ' maintenance-contributiontype-list',
  MAINTENANCE_INTERVENTION_LIST: ' maintenance-intervention-list',
  MAINTENANCE_COUNTRY_LIST: ' maintenance-country-list',
  MAINTENANCE_STATE_LIST: 'maintenance-state-list',
  MAINTENANCE_DISTRICT_LIST: 'maintenance-district-list',
  MAINTENANCE_MUKIM_LIST: 'maintenance-mukim-list',
  MAINTENANCE_SDG_LIST: 'maintenance-sdg-list',
  MEMBERS_LIST: 'members-list',
  NGO_LIST: 'ngo-list',
  PARTNERS_LIST: 'partners-list',
  SECRETARIATS_LIST: 'secretariats-list',
  SUBMISSION_LIST: 'submission-list',
  USERS_LIST: 'users-list',
  PERMISSION_INTERNAL_LIST: 'permission-internal-list',
  PERMISSION_EXTERNAL_LIST: 'permission-external-list',
}

export {QUERIES}
